import { eurocentToEuro, euroToEurocent } from "@/helper/formattingValues";

// prices are typed in euro (comma or dot) but stored in eurocent, except for entities that keep euro
export const toPriceFormValue = (raw: string, convertToEurocent: boolean) => {
  if (raw === "" || !convertToEurocent) return raw;
  const numeric = parseFloat(raw.toString().replace(",", "."));
  return isNaN(numeric) ? raw : euroToEurocent(numeric);
};

export const toPriceDisplayValue = (
  formValue: any,
  convertToEurocent: boolean
) =>
  formValue !== "" && convertToEurocent ? eurocentToEuro(formValue) : formValue;
